import APIClient from './index';

export const fetchCollectionAnalysisList = params =>
  APIClient.get('Admin/collection-analysis', { params }).then(response => response.data);

export const fetchCollectionAnalysisSummary = params =>
  APIClient.get('Admin/collection-analysis/summary', { params }).then(response => response.data);

export const updateCollectionAnalysisAdjustment = (analysisId, updates) =>
  APIClient.put(`Admin/collection-analysis/${analysisId}/adjustment`, updates).then(response => response.data);

export const searchCollectionAnalysis = params =>
  APIClient.get('Admin/collection-analysis/search', { params }).then(response => response.data);
